export function computeTheoreticalSpeedKn(
  pitchMm: number | null | undefined,
  avgRpm: number | null | undefined,
): number | null {
  if (pitchMm == null || avgRpm == null) return null;
  if (!Number.isFinite(pitchMm) || !Number.isFinite(avgRpm)) return null;
  return ((pitchMm / 1000) * avgRpm * 60) / 1852;
}

export function computeSlipPercent(
  theoreticalSpeed: number | null | undefined,
  avgStw: number | null | undefined,
): number | null {
  if (theoreticalSpeed == null || avgStw == null) return null;
  if (!Number.isFinite(theoreticalSpeed) || !Number.isFinite(avgStw)) return null;
  if (theoreticalSpeed === 0) return null;
  return ((theoreticalSpeed - avgStw) / theoreticalSpeed) * 100;
}
